import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideChevronDown = ({ width = 16, height = 16, color = '#1F1F1F' }) =>
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M3 6L8 11L13 6' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>;

IconPowertrainGuideChevronDown.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideChevronDown;
